import { render, staticRenderFns } from "./ListCarMantainace.vue?vue&type=template&id=8b363288"
import script from "./ListCarMantainace.vue?vue&type=script&lang=js"
export * from "./ListCarMantainace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports